module.exports = __webpack_public_path__ + "img/assoon.7516f2cb.png";